module.exports = __webpack_public_path__ + "static/media/upgrade-kitchen.017cc56e.jpg";